import { render } from "./RightHome.vue?vue&type=template&id=324c4fbc&scoped=true"
import script from "./RightHome.vue?vue&type=script&lang=js"
export * from "./RightHome.vue?vue&type=script&lang=js"

import "./RightHome.vue?vue&type=style&index=0&id=324c4fbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324c4fbc"]])

export default __exports__